import {
  createAddItemToCart,
  createNewsletter,
  getBannerList,
  getBlogAllListItems,
  getCatalogFilters,
  getCatalogList,
  getCategories,
  getClientList,
  getItemsFromCart,
  getItemsFromCartSize,
  getPageNumberTotal,
  getProducts,
  getProductsCategoriesType,
  getProductsWithPagination,
  getRelateddProducts,
  getSearchProducts,
  getSliderList,
  removeItemFromCart,
  sendContactForm,
  sentContactFormPath,
  sentNewsletterFormPath,
  updateCartFinish,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { globalActions } from "../reducers/globalActions";
import i18next from "i18next";
import { toast } from "react-toastify";

export const fetchContactFormSent = (
  dataValues,
  showMessageContact,
  navigate
) => {
  return (dispatch) => {
    return apiService
      .post(sentContactFormPath(), dataValues)
      .then((response) => {
        showMessageContact();
        console.log(response, "respo");
      })
      .catch((err) => {
        navigate("", { replace: true });
        console.log(err, "err");
      });
  };
};

export const fetchNewsletterFormSent = (dataValues, showMessageContact) => {
  return (dispatch) => {
    return apiService
      .post(sentNewsletterFormPath(), dataValues)
      .then((response) => {
        showMessageContact();
        console.log(response, "respo");
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchBlogListItems = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(getBlogAllListItems(i18next.language, id))
      .then((response) => {
        dispatch(globalActions.fetchItemsListBlogAll(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchCategoriesList = () => {
  return (dispatch) => {
    return apiService
      .get(getCategories())
      .then((response) => {
        dispatch(globalActions.fetchItemsCategoriesAll(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchProductsHomeCategoryAll1 = (dataValue) => {
  return (dispatch) => {
    return apiService
      .post(getProducts(), dataValue)
      .then((response) => {
        dispatch(globalActions.fetchProductsAll1(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchProductsHomeCategoryAll2 = (dataValue) => {
  return (dispatch) => {
    return apiService
      .post(getProducts(), dataValue)
      .then((response) => {
        dispatch(globalActions.fetchProductsAll2(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchRelatedProductsAll = (dataValue) => {
  return (dispatch) => {
    return apiService
      .post(getProducts(), dataValue)
      .then((response) => {
        dispatch(globalActions.fetchRelatedProductsAll(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchRelatedProduct = (id) => {
  const languageId = i18next.language == "sr" ? 1 : 2;
  return (dispatch) => {
    return apiService
      .get(getRelateddProducts(id, languageId))
      .then((response) => {
        dispatch(globalActions.fetchRelatedProductsAll(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchProductsDetail = (id, id_language) => {
  const languageId = id_language == "sr" ? 1 : 2;

  return (dispatch) => {
    dispatch(globalActions.actionStartProductDetail());
    dispatch(globalActions.resetProductDetail()); // ✅ reset na null

    return apiService
      .get(getProducts(id, languageId))
      .then((response) => {
        dispatch(globalActions.fetchDetailProduct(response.data)); // ✅ samo jednom
      })
      .catch((err) => {
        console.log(err, "err");
        dispatch(globalActions.fetchDetailProduct(null)); // ili setError/notFound
      });
  };
};

export const fetchProductsAllWithPagination = (dataValue) => {
  return (dispatch) => {
    dispatch(globalActions.actionStartCatalog2());
    return apiService
      .post(getProductsWithPagination(), dataValue)
      .then((response) => {
        dispatch(globalActions.fetchProductsAll(response.data.items));
        // dispatch(globalActions.dataCatalogFilters(response.data.filters));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchSearchProductsAll = (dataValue) => {
  return (dispatch) => {
    dispatch(globalActions.actionStartSearch());
    return apiService
      .post(getSearchProducts(), dataValue)
      .then((response) => {
        dispatch(globalActions.dataSearchProductsList(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchCilentsList = () => {
  return (dispatch) => {
    return apiService
      .get(getClientList())
      .then((response) => {
        dispatch(globalActions.dataClientList(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchSlidersList = () => {
  return (dispatch) => {
    return apiService
      .get(getSliderList())
      .then((response) => {
        dispatch(globalActions.dataSliderList(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchBannersList = () => {
  return (dispatch) => {
    return apiService
      .get(getBannerList())
      .then((response) => {
        dispatch(globalActions.dataBannerList(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchCatalogList = (type) => {
  return (dispatch) => {
    return apiService
      .get(getCatalogList(type))
      .then((response) => {
        dispatch(globalActions.dataCatalogList(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchCatalogList2 = (type) => {
  return (dispatch) => {
    return apiService
      .get(getCatalogList(type))
      .then((response) => {
        dispatch(globalActions.dataCatalogList2(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchPageNumberTotal = (dataValue) => {
  return (dispatch) => {
    return apiService
      .post(getPageNumberTotal(), dataValue)
      .then((response) => {
        dispatch(globalActions.dataCatalogPagination(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchCartFinish = (dataValue, navigate) => {
  return (dispatch) => {
    return apiService
      .post(updateCartFinish(), dataValue)
      .then((response) => {
        // console.log(response?.data, 11);
        // console.log(dataValue.payment_method);
        if (dataValue.payment_method == 2) {
          // console.log(response?.data, 22);
          return response.data;
        } else {
          navigate("/success-page");
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message, { theme: "colored" });
      });
  };
};

export const sendContactFormFunction = (
  dataValue,
  t,
  resetForm,
  resetCaptcha
) => {
  return (dispatch) => {
    return apiService
      .post(sendContactForm(), dataValue)
      .then((response) => {
        console.log(response.data);
        toast.success(t("other.send_contact_form_message"), {
          theme: "colored",
        });
        resetForm();
        resetCaptcha();
      })
      .catch((err) => {
        toast.success(t("other.send_contact_form_message_error"), {
          theme: "colored",
        });
        resetCaptcha();
      });
  };
};

//dodavanje stavke u korpu / kreiranje korpe ako nema order_id
export const fetchAddProductToCart = (dataValue, t) => {
  return (dispatch) => {
    return apiService
      .post(createAddItemToCart(), dataValue)
      .then((response) => {
        // resetCaptcha();
        // dispatch(globalActions.dataCartInfo(response.data.order));
        // dispatch(globalActions.dataCartItemsInfo(response.data.order_items));
        // localStorage.setItem("cart", JSON.stringify(response.data.order));
        dispatch(fetchGetItemsFromCart());
        toast.success(t("other.added_to_cart"), { theme: "colored" });
      })
      .catch((err) => {
        // resetCaptcha();
        toast.error(err.message, { theme: "colored" });
      });
  };
};

export const fetchAddNewsletter = (dataValue, resetValue) => {
  return (dispatch) => {
    return apiService
      .post(createNewsletter(), dataValue)
      .then((response) => {
        resetValue();
        toast.success("Uspešno ste se prijavili na newsletter", {
          theme: "colored",
        });
      })
      .catch((err) => {
        // resetCaptcha();
        if (err.status == 409) {
          toast.error("Ova e-mail adresa je već prijavljena na newsletter.", {
            theme: "colored",
          });
        } else if (err.status == 500) {
          toast.error("Greška prilikom prijave na newsletter.", {
            theme: "colored",
          });
        } else if (err.status == 400) {
          toast.error("E-mail adresa je obavezna.", {
            theme: "colored",
          });
        }
      });
  };
};

//dohvatanje stavki za korpu
export const fetchGetItemsFromCart = () => {
  return (dispatch) => {
    return apiService
      .get(getItemsFromCart())
      .then((response) => {
        dispatch(globalActions.dataCartInfo(response.data));
        dispatch(fetchGetItemsFromCartSize());
        toast.success(response.data.message, { theme: "colored" });
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

//dohvatanje stavki za korpu
export const fetchGetItemsFromCartSize = () => {
  return (dispatch) => {
    return apiService
      .get(getItemsFromCartSize())
      .then((response) => {
        dispatch(globalActions.dataCartInfoSize(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

//brisanje stavke iz korpu
export const fetchRemoveItemFromCart = (id) => {
  return (dispatch) => {
    return apiService
      .post(removeItemFromCart(id))
      .then((response) => {
        dispatch(fetchGetItemsFromCart());

        toast.success(response.data.message, { theme: "colored" });
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchCatalogFilters = (dataValue) => {
  return (dispatch) => {
    dispatch(globalActions.actionStartCatalog());
    return apiService
      .post(getCatalogFilters(), dataValue)
      .then((response) => {
        dispatch(globalActions.dataCatalogFilters(response.data));
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};

export const fetchProductsCategoriesTypeAll = (type) => {
  return (dispatch) => {
    return apiService
      .get(getProductsCategoriesType(type))
      .then((response) => {
        if (type === "mesecnaAkcija") {
          dispatch(globalActions.fetchProductsMesecnaAkcija(response.data));
        } else if (type === "popularno") {
          dispatch(globalActions.fetchProductsPopularno(response.data));
        } else if (type === "izdvajamo") {
          dispatch(globalActions.fetchProductsIzdvajamoIzPonude(response.data));
        } else if (type === "preporucujemo") {
          dispatch(globalActions.fetchProductsPreporucujemo(response.data));
        } else if (type === "specijalnaAkcija") {
          dispatch(globalActions.fetchProductsSpecijalnaAkcija(response.data));
        } else if (type === "ponovoNaStanju") {
          dispatch(globalActions.fetchProductsPonovoNaStanju(response.data));
        }
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
};
